<template>
  <v-row>
    <v-col lg="8" class="mx-auto">
      <v-card class="pa-2">
        <v-card-title>
          <v-text-field
            v-model="search"
            :label="$t('快速搜尋')"
            single-line
            hide-details
            append-icon="mdi-magnify"
            @click:append="onSearch"
            @keydown.enter="onSearch"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="items"
          :mobile-breakpoint="0"
          :items-per-page="15"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :search="search"
          :options.sync="options"
          :server-items-length="pagination.total"
          :footer-props="footerProps"
          >
          <template v-slot:item.created_at="{ item }">
            <span class="caption">{{ item.created_at | date('YYYY/MM/DD LT') }}</span>
          </template>
          <template v-slot:item.nationality="{ item }">
            {{  item.nationality | nationality }}
          </template>
          <template v-slot:item.can_apply="{ item }">
            <p v-if="!item.can_apply" class="mb-0 red--text">NO</p>
            <p v-else-if="item.line_count == 0" class="mb-0 blue--text">YES</p>
            <p v-else class="mb-0 blue--text">{{ `YES(${item.line_count+1})` }}</p>
          </template>
          <template v-slot:item.status="{ item }">
            {{ $t(item.status) }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { date, nationality } from '../../libs/filters';
import { pagination } from '../../libs/mixins';

export default {
  mixins: [
    pagination,
  ],

  filters: {
    date, nationality,
  },

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$t("日期"), value: 'created_at', width: '20%' },
        { text: this.$t("證號"), value: 'identity_no', width: '30%' },
        { text: this.$t("生日"), value: 'birthday' },
        { text: this.$t("國籍"), value: 'nationality' },
        { text: this.$t("結果"), value: 'can_apply' },
        { text: this.$t("備註"), value: 'status' },
      ];
    },

    ...mapState('queries', {
      items: 'all'
    }),
  },

  mounted() {
    this.fetchAll();
  },

  methods: {
    ...mapActions('queries', {
      queryResults: 'get'
    }),
  }
}
</script>
